import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { FormControl } from '@mui/material'

import GBFlag from 'resources/images/en.svg'
import CNFlag from 'resources/images/zh.svg'

const LanguageComponent = () => {
    const { i18n } = useTranslation()
    const [currentLanguage, setCurrentLanguage] = useState('en')

    useEffect(() => {
        setCurrentLanguage(i18n.language === 'zh' ? 'zh' : 'en')
    }, [i18n.language])

    const handleChange = (e) => {
        const lang = e.target.value

        window.localStorage.setItem('lang', lang)
        i18n.changeLanguage(lang)
    }

    return (
        <FormControl size='small'>
            <Select
                value={currentLanguage}
                onChange={handleChange}
                MenuProps={{
                    disableScrollLock: true,
                }}
                autoWidth
                sx={{
                    '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '0px',
                        },
                    },
                    '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                        borderWidth: 0,
                    },
                    '.MuiOutlinedInput-notchedOutline': {
                        borderWidth: 0,
                    },
                    '.MuiSvgIcon-root': {
                        color: 'transparent',
                        width: 'fit-content',
                    },
                    '& .MuiSelect-select': {
                        paddingRight: '0 !important',
                    },
                    fontSize: 14,
                    color: 'transparent',
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Language selector' }}
                className='text-sm'
                renderValue={(selected) => (
                    <div className='flex items-center'>
                        {selected === 'zh' ? (
                            <img src={CNFlag} alt='中文' className='w-5 h-5' />
                        ) : (
                            <img src={GBFlag} alt='English' className='w-5 h-5' />
                        )}
                    </div>
                )}
            >
                <MenuItem value='en'>
                    <div className='flex items-center'>
                        <img src={GBFlag} alt='English' className='w-5 h-5 mr-2' />
                        EN
                    </div>
                </MenuItem>
                <MenuItem value='zh'>
                    <div className='flex items-center'>
                        <img src={CNFlag} alt='中文' className='w-5 h-5 mr-2' />
                        中文
                    </div>
                </MenuItem>
            </Select>
        </FormControl>
    )
}

export default LanguageComponent
